module.exports = __webpack_public_path__ + "img/yy.438fee43.jpg";